/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Member_DescriptionInputs */

const en_newsletter_member_description = /** @type {(inputs: Newsletter_Member_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New issues delivered straight to your inbox.`)
};

/**
* | output |
* | --- |
* | "New issues delivered straight to your inbox." |
*
* @param {Newsletter_Member_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_member_description = /** @type {((inputs?: Newsletter_Member_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Member_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_member_description(inputs)
});